import { IRole } from "../../role-and-permission/pages/roles/Role";

export type UserStatus =
  | "pending"
  | "approved"
  | "active"
  | "rejected"
  | "disabled";

export interface IMember {
  id: number;
  name: string;
  email: string;
  password?: string;
  role_id?: number;
  roles?: Array<IRole>;
  status?: UserStatus;
}

export const defaultMember: IMember = {
  id: 0,
  name: "",
  email: "",
  password: "",
  role_id: 4,
};
